import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircleIcon, PhoneIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { business } from "../data/business";
import { ui } from "../data/ui";
import { useScrollPast } from "../hooks/useScrollPast";
export function FloatingCTA() {
  const {
    t
  } = useLanguage();
  const visible = useScrollPast(560);
  return <AnimatePresence data-id="element-122" data-mp="2pj650r70myc2">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-40 flex items-center gap-2 lg:hidden" data-id="element-123" data-mp="2kleb5rmt9258">
          <a href={business.whatsappHref} target="_blank" rel="noreferrer" aria-label="WhatsApp" className="grid h-12 w-12 place-items-center rounded-full border border-gold/60 bg-ink text-gold shadow-lg" data-id="element-124" data-mp="38aywgh6fsbho">
            <MessageCircleIcon className="h-5 w-5" aria-hidden="true" data-id="element-125" data-mp="2z425k4xp12ug" />
          </a>
          <a href={business.phoneHref} aria-label={`${t(ui.common.callNow)} ${business.phoneDisplay}`} className="grid h-12 w-12 place-items-center rounded-full border border-gold/60 bg-ink text-gold shadow-lg" data-id="element-126" data-mp="332rgzrz68abg">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="2fdp1oqs0etk4" />
          </a>
          <a href="#contact" className="btn-gold h-12 rounded-full px-5 shadow-glow" data-id="element-128" data-mp="2kctb9iiuitaz">
            {t(ui.common.getQuote)}
          </a>
        </motion.div>}
    </AnimatePresence>;
}